import request from '@/utils/request'

let PaymentApi = {
    /*获取数据*/
    getData(data, errorback) {
        return request._get('/shop/plus.payment/index', data, errorback);
    },
    /*保存数据*/
    saveData(data, errorback) {
        return request._post('/shop/plus.payment/index', data, errorback);
    },
}
export default PaymentApi;



// WEBPACK FOOTER //
// ./src/api/payment.js